export default __webpack_public_path__ + "static/media/BillOn.fa21e47a.svg";